import React, { Component } from "react"
import PropTypes from "prop-types"
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer'
import Collapse from 'react-collapse'
import classnames from 'classnames'
import "./Accordion.css"
import {I18n} from "react-i18next";

class Accordion extends Component {
    renderHeading() {
        return this.props.renderHeading && this.props.renderHeading()
    }

    renderPanel({ panelKey, height }) {
        const isOpened = this.props.openedPanel === panelKey

        const content = (
            <I18n ns={[this.props.model, 'platform']}>
                {t => this.props.renderPanel(panelKey, t, this.props)}
            </I18n>
        )

        // mainAccordion just switches between panels (list/form/charts) instead of
        // expanding/collapsing them, so it should snap instantly instead of animating
        // through react-collapse's height spring, which was causing the panel content
        // (and its scrollbar) to flicker while resizing frame by frame.
        if (this.props.mainAccordion) {
            return (
                <div
                    key={panelKey}
                    className="Accordion-Collapse-collapse"
                    style={{ height: isOpened ? height : 0, overflow: 'hidden' }}
                >
                    <div className={classnames(this.props.panelClassName, { fillAllHeight: height })}>
                        {content}
                    </div>
                </div>
            )
        }

        return (
            <Collapse
                key={panelKey}
                isOpened={isOpened}
                fixedHeight={height}
                theme={{
                    //collapse: 'Accordion-Collapse-collapse',
                    collapse: classnames(
                        'Accordion-Collapse-collapse',
                        `${panelKey === 'innerList' && this.props.openedPanel === 'innerList'  ? 'Accordion-innerAccordion': ''}`,
                    ),
                    content: classnames(
                        this.props.panelClassName,
                        { fillAllHeight: height }
                    )
                }}
            >
                {content}
            </Collapse>
        )
    }

    renderFillingPanels() {
        return (
            <div className={`Accordion-panels ${this.props.mainAccordion ? 'Accordion-borderless-panels' : ''}`}>
                <AutoSizer>
                    {({ height, width }) => (
                        <div
                            style={{ height: `${height}px`, width: `${width}px`}}
                        >
                            {this.props.panelKeys.map(
                                panelKey => this.renderPanel({ panelKey, height })
                            )}
                        </div>
                    )}
                </AutoSizer>
            </div>
        )
    }

    renderPanels() {
        return (
            <div className="Accordion-panels">
                {this.props.panelKeys.map(
                    panelKey => this.renderPanel({ panelKey })
                )}
            </div>
        )
    }

    render() {
        return (
            <div className="Accordion panel-group">
                {this.renderHeading()}
                {this.props.fillAllHeight
                    ? this.renderFillingPanels()
                    : this.renderPanels()
                }
            </div>
        )
    }
}

Accordion.propTypes = {
    openedPanel: PropTypes.string.isRequired,
    panelKeys: PropTypes.arrayOf(PropTypes.string),
    renderHeading: PropTypes.func,
    renderPanel: PropTypes.func.isRequired,
    fillAllHeight: PropTypes.bool.isRequired,
    panelClassName: PropTypes.string
}

export default Accordion;
